<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="3">
              <v-select
                label="Setor"
                v-model="form.filters.setor"
                :items="form.lists.setores"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-select
                label="Função"
                v-model="form.filters.funcao"
                :items="form.lists.funcoes"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                :text="'Buscar'"
                :icon="'mdi-magnify'"
                @click="buscarProfissionais()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                :text="'Limpar'"
                :icon="'mdi-eraser'"
                @click="resetForm()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                :text="'Atribuir Perfil em Lote'"
                :icon="'mdi-account-multiple-plus'"
                @click="openDialogAtribuirPerfilEmLote()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
				<v-row class="d-flex justify-center mt-5 mb-5">
					<v-col cols="3">
						<v-card>
							<div class="mb-1">
								<v-icon>mdi mdi-pen</v-icon>
								Nome da Gerência: 
							</div>
							<div class="text-caption">{{ organograma?.nome }}</div>
						</v-card>
					</v-col>
					<v-col cols="3">
						<v-card>
							<div class="mb-1">
								Sigla da Gerência:
							</div>
							<div class="text-caption">{{ organograma?.sigla }}</div>
						</v-card>
					</v-col>
					<v-col cols="3">
						<v-card>
							<div class="mb-1">
								<v-icon>mdi mdi-office-building-marker-outline</v-icon>
								Secretaria Executiva: 
							</div>
							<div class="text-caption">{{ organograma?.secretariaExecutiva }}</div>
						</v-card>
					</v-col>
				</v-row>
        <v-data-table
          ref="table"
          class="mt-5"
          item-key="id"
          v-model="profissionaisSelecionados"
          :headers="headers"
          :items="form.lists.profissionais"
          :footer-props="$footerProps"
          :items-per-page="10"
          @item-expanded="obterPerfilProfissional"
					show-select
          show-expand
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nomeSocial || item.nome }}
          </template>
          <template v-slot:[`item.setor`]="{ item }">
            {{ item.setor?.nome }}
          </template>
          <template v-slot:[`item.funcao`]="{ item }">
            {{ item.funcao?.nome }}
          </template>
					<template v-slot:expanded-item="{ headers, item }">
						<td :colspan="headers.length">
							<v-chip-group active-class="primary--text" column>
								<v-chip v-for="(perfil, i) in item.perfis" :key="i">
									<v-icon small>mdi-account-multiple</v-icon>
									{{ perfil.nome }}
								</v-chip>
							</v-chip-group>
						</td>
					</template>
          <template v-slot:[`item.ativo`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sigfoco-tooltip
              :text="'Atribuir Perfil'"
              :icon="'mdi-account-multiple-plus'"
              small
              @click="openDialogAtribuirPerfil(item)"
            ></sigfoco-tooltip>
          </template>
        </v-data-table>
      </v-container>
      <AtribuirPerfilEmLoteDialog
        :visible="dialogAtribuirPerfilEmLote.visible"
        :content="dialogAtribuirPerfilEmLote.content"
        :edit="dialogAtribuirPerfilEmLote.edit"
        @onClose="dialogAtribuirPerfilEmLote.close()"
        @onSave="buscarProfissionais()"
      ></AtribuirPerfilEmLoteDialog>
      <AtribuirPerfilDialog
        :visible="dialogAtribuirPerfil.visible"
        :content="dialogAtribuirPerfil.content"
        :edit="dialogAtribuirPerfil.edit"
        @onClose="dialogAtribuirPerfil.close()"
        @onSave="buscarProfissionais()"
      ></AtribuirPerfilDialog>
    </div>
  </template>
  
  <script>
  import { Dialog } from "~/commons/classes/dialog";
  import { Organograma } from "~/commons/classes/organograma";
  import AuthService from "~/services/auth.service";
  import ManterOrganogramaService from "~/services/manter-organograma.service";
  import ManterUsuarioService from "~/services/manter-usuario.service";
  import AtribuirPerfilEmLoteDialog from "./dialogs/AtribuirPerfilEmLoteDialog.vue";
  import AtribuirPerfilDialog from "./dialogs/AtribuirPerfilDialog.vue";
  
  export default {
    name: "ManterOrganogramaView",
    mixins: [
      ManterOrganogramaService,
      ManterUsuarioService,
      AuthService
    ],
    components: {
      AtribuirPerfilEmLoteDialog,
      AtribuirPerfilDialog,
    },
    data: () => ({
      dialogAtribuirPerfilEmLote: Dialog.Build(),
      dialogAtribuirPerfil: Dialog.Build(),
      organograma: Organograma.Build(),
      profissionaisSelecionados: [],
      form: {
        filters: {
          setor: null,
          funcao: null,
        },
        lists: {
          profissionais: [],
          setores: [],
          funcoes: [],
        },
      },
      headers: [
        { text: "Nome do Usuário", align: "center", value: "nome" },
        { text: "Setor", align: "center", value: "setor" },
        { text: "Função", align: "center", value: "funcao" },
        { text: "Perfil", align: "center", value: "data-table-expand" },
        { text: "Situação", align: "center", value: "ativo" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
    }),
    methods: {
			obterDadosOrganograma(id) {
        this.$refs.table.expanded = [];
				this.$gerenciarOrganograma(id).then(({ data }) => {
          this.organograma = new Organograma(data.resposta);
          this.form.lists.profissionais = this.organograma.profissionais;
          this.obterSetoresDosProfissionais();
          this.obterFuncoesDosProfissionais();
          this.filtrarDadosProfissionais(this.form.filters, this.form.lists.profissionais);
        });
			},
      buscarProfissionais() {
        this.obterDadosOrganograma(this.$route.params.id);
      },
      filtrarDadosProfissionais() {
        this.form.lists.profissionais = this.organograma.profissionais.filter((profissional) => {
          return ((!this.form.filters.setor || (profissional.setor.id === this.form.filters.setor))
            && (!this.form.filters.funcao || (profissional.funcao.id === this.form.filters.funcao))
          );
        });
      },
      obterSetoresDosProfissionais() {
        this.form.lists.setores = this.form.lists.profissionais.map((profissional) => profissional.setor);
      },
      obterFuncoesDosProfissionais() {
        this.form.lists.funcoes = this.form.lists.profissionais.map((profissional) => profissional.funcao);
      },
      async obterPerfilProfissional({ item , value}) {
        if (value) {
          const { data } = await this.$obterPerfisDoUsuario({ id: item.id });
          const profissional = this.form.lists.profissionais.find((p) => p.id === item.id);
          if (profissional) {
            this.$set(profissional, 'perfis', data.lista);
          }
        }
      },
      openDialogAtribuirPerfilEmLote() {
        if (this.profissionaisSelecionados.length >= 2) {
          this.dialogAtribuirPerfilEmLote.open({
          ...this.organograma,
          profissionais: this.profissionaisSelecionados,
        });
        } else {
          return this.$notifyError("Para atribuir um perfil em lote, selecione pelo menos dois usuários.");
        }
      },
      openDialogAtribuirPerfil(organograma) {
        organograma.nome = organograma.nomeSocial || organograma.nome;
        this.obterPerfilProfissional({ item: organograma, value: true });
        this.dialogAtribuirPerfil.open(organograma);
      },
      resetForm() {
        this.$refs.table.expanded = [];
        this.form.lists.profissionais = [];
        this.profissionaisSelecionados = [];
        this.$resetForm();
      },
    },
    mounted() {
			this.obterDadosOrganograma(this.$route.params.id);
    },
  };
  </script>
  